export default __webpack_public_path__ + "static/media/panda-1.770efbb0.jpg";